/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'react',
	'ca-ui-toolkit',
	'prop-types',
	'./CustomVisualsContentComponent',
	'./CustomVisualsComponentHeader',
	'../../../widgets/livewidget/nls/StringResources'
], function(
	React,
	UI_Toolkit,
	PropTypes,
	CustomVisualsContentComponent,
	CustomVisualsComponentHeader,
	StringResources
) {

	const { Component } = React;
	const { Label } = UI_Toolkit;
	const { VSpacer, FlexLayout, FlexItem } = UI_Toolkit;

	class CustomVisualsComponent extends Component {

		constructor(props) {
			super(props);

			this.state = {
				items: this.props.items,
				isRefreshing: this.props.isRefreshing
			};
		}

		componentWillReceiveProps(nextProps) {
			this.setState({
				items: nextProps.items,
				isRefreshing: nextProps.isRefreshing
			});
		}

		render () {
			const { customVisAction } = this.props;
			const { items, isRefreshing } = this.state;
			const { handlers, dashboardApi } = this.props;

			return (
				<FlexLayout
					fullHeight
					direction='column'
					justifyContent='flex-start'
				>
					<FlexItem grow={5}
						className='vis-custom-visuals-container'
					>
						<FlexLayout
							fullHeight
							direction='column'
							justifyContent='flex-start'
						>
							<FlexItem>
								<FlexLayout
									direction='row'
									justifyContent='space-between'
								>
									<FlexItem alignSelf={'flex-start'}>
										<Label className='vis-custom-vis-visuals-label' label={StringResources.get('extVisCustomVisuals')}/>
									</FlexItem>
									{customVisAction.canManage() && (
										<FlexItem
											alignSelf='flex-end'
											title={StringResources.get('extVisAddCustomVisual')}
										>
											<CustomVisualsComponentHeader
												customVisAction={customVisAction}
												handlers={handlers}
											/>
										</FlexItem>
									)}
								</FlexLayout>
							</FlexItem>
							<FlexItem>
								<VSpacer size={2} />
							</FlexItem>
							<FlexItem
								basis={'0%'}
								grow={1}
								shrink={1}
							>
								<CustomVisualsContentComponent
									items={items}
									handlers={handlers}
									isRefreshing={isRefreshing}
									customVisAction={customVisAction}
									dashboardApi={dashboardApi} />
							</FlexItem>
							<FlexItem>
								<VSpacer size={2} />
							</FlexItem>
						</FlexLayout>
					</FlexItem>
				</FlexLayout>
			);
		}
	}

	CustomVisualsComponent.propTypes = {
		items: PropTypes.array.isRequired,
		handlers: PropTypes.shape({
			componentDidMountCallback: PropTypes.func.isRequired,
			componentWillUnmountCallback: PropTypes.func.isRequired,
			refreshCustomVisDefinitions: PropTypes.func.isRequired
		}).isRequired,
		isRefreshing: PropTypes.bool,
		dashboardApi:PropTypes.object.isRequired,
		customVisAction: PropTypes.object.isRequired
	};

	CustomVisualsComponent.defaultProps = {
		isRefreshing: false
	};

	return CustomVisualsComponent;
});
